module.exports = __webpack_public_path__ + "img/bell.a681de24.png";